import { useWindowScroll as useWindowScrollBase } from '@vueuse/core'

export const useWindowScroll = createGlobalState(() => {
	const { x, y } = useWindowScrollBase()
	return {
		x: useThrottle(x, 50),
		y: useThrottle(y, 50),
	}
})
